import RootStore from './RootStore';
import QuotationStore from './QuotationStore';

const stores = {
    rootStore: new RootStore(),
    quotationStore: new QuotationStore(),
};
console.log('stores', stores);

export default stores;
